import React from "react";
import { Row } from "react-bootstrap";
import UserDefinedField from "@components/UserDefinedField/UserDefinedField";
import { ProjectVariable } from "../../../../Admin/ProfessionalServices/common/types/ProjectVariable";

interface Props {
  variables: ProjectVariable[];
  values: Record<string, string>;
  onChange: (name: string, value: string) => void;
}

const FULL_WIDTH = { flex: "0 0 100%", maxWidth: "100%" };

// UserDefinedField's dropdown has no empty option, so a variable without a
// default would look chosen while its value is still blank.
const withPlaceholder = (options: ProjectVariable["select_options"]) =>
  options?.length ? [{ key: "Select...", value: "" }, ...options] : options;

const SaveAsStandardVariables = ({ variables, values, onChange }: Props) => (
  <>
    <p className="mt-3 mb-2">
      Standard services require the following:
    </p>
    <Row>
      {variables.map((variable) => (
        <UserDefinedField
          key={variable.name}
          style={FULL_WIDTH}
          fieldDefinition={{
            ...variable,
            select_options: withPlaceholder(variable.select_options),
            "select-options": withPlaceholder(variable["select-options"]),
            value: values[variable.name] ?? variable.value ?? "",
          }}
          onChange={(changed) => onChange(variable.name, changed.value ?? "")}
        />
      ))}
    </Row>
  </>
);

export default SaveAsStandardVariables;
